// Content.js
import React from 'react';
import '../pages/security-questions/SecurityQuestions.css';

const Content = ({ children }) => <div className={`content`}>{children}</div>;

export default Content;
